<div class="container">
  @if (calendar$ | async; as calendar) {
  <app-bookme-calendar
    [calendar]="calendar"
    [timeSlots]="timeSlots$ | async"
    [rescheduledMeetingInfo]="rescheduledMeetingInfo$ | async"
    [loadTimeSlotsError]="loadTimeSlotsError"
    [rescheduling]="true"
    (timeSlotSelected)="onTimeSlotSelected($event)"
    (timeRangeChanged)="onTimeRangeChanged($event)"
    (timezoneChanged)="onTimeZoneChanged($event, false)"
    [displayLocationEdit]="true"
    (locationChanged)="onLocationChange($event)"
    (confirmChanges)="onConfirmChanges()"
  >
  </app-bookme-calendar>
  }
</div>
